import { handleActions } from "redux-actions";
import { ACCESS_CONTROL } from "constants/action-types";

export interface IAccessControlState {
    error: null | { brandName?: string };
    hasAccess: boolean;
}

const initialState: IAccessControlState = {
    error: null,
    hasAccess: true,
};

export const accessControlReducer = handleActions(
    {
        [ACCESS_CONTROL.ERROR.SET]: (state, { payload }) => {
            return {
                ...state,
                error: payload,
            };
        },
        [ACCESS_CONTROL.HAS.ACCESS]: (state, { payload }) => {
            return {
                ...state,
                hasAccess: payload,
            };
        },
    } as any,
    initialState,
);
